import React from 'react';
import GridContainer from '@jumbo/components/GridContainer';
import GridItem from '@jumbo/components/GridItem';
import SimpleFilter from './SimpleFilter';
import ViewListSearchBar from './ViewListSearchBar';
import { Box, Divider } from '@mui/material';

const ViewListHeader = ({ tableDataParams, setTableDataParams, isLoading, sortOptions, displayedRangeLabel }) => {
  return (
    <GridContainer sx={{ mt: 1, alignItems: 'flex-start' }}>
      <GridItem xs={12} md={3} sm={4}>
        <SimpleFilter
          options={sortOptions}
          tableDataParams={tableDataParams}
          setTableDataParams={setTableDataParams}
          displayedRangeLabel={displayedRangeLabel}
        />
      </GridItem>

      <GridItem xs={12} md={9} sm={8}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
          <ViewListSearchBar
            tableDataParams={tableDataParams}
            setTableDataParams={setTableDataParams}
            isLoading={isLoading}
          />
        </Box>
      </GridItem>
      <GridItem xs={12}>
        <Divider />
      </GridItem>
    </GridContainer>
  );
};

export default ViewListHeader;
